import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import {
  Button,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Paper,
  Grid,
  Tooltip
} from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';

import RfsStyles from './tapa.module.css';
import commonStyles from '../common/common.module.css';
import MaterialTable from 'material-table';
import Zoom from '@material-ui/core/Zoom';
import moment from 'moment';
import TapaModel from '../../models/TapaForm';
import unlink from '../../assets/unlink.png';

const styles = (theme: Theme) =>
  createStyles({
    linkButton: {
      transform: 'rotate(140deg)',
      width: '20px',
      cursor: 'pointer'
    }
  });

interface TruckCompanyProps {
  classes: any;
  modalOpen: boolean;
  handleClose: (type: string) => void;
  openConfirmation: (type: string, tapaId: number, orderNumber: string) => void;
  tapaForm: TapaModel;
}

const tapaLinkModalComponent = (props: TruckCompanyProps) => {
  const { classes } = props;

  return (
    <Dialog
      open={props.modalOpen}
      onClose={() => props.handleClose('vieworders')}
      aria-labelledby='form-dialog-title'
      maxWidth={'sm'}
      fullWidth={true}
      TransitionComponent={Zoom}
      transitionDuration={500}>
      <DialogTitle id='form-dialog-title'>
        <div className={RfsStyles.dialogTitle}>
          <span className={RfsStyles.name}>Linked Orders</span>
          <IconButton
            aria-label='Close'
            className={RfsStyles.close}
            onClick={() => props.handleClose('vieworders')}>
            <CloseIcon color='primary' />
          </IconButton>
        </div>
        <hr />
      </DialogTitle>
      <DialogContent>
        <div style={{ paddingTop: 10 }}>

          {/* <Button
            color='primary'
            variant='contained'
            className={RfsStyles.shipHsavebtn}
            onClick={() => props.handleSave()}
            disabled={ !props.awbInfo.code || !props.awbInfo.number }
          >
            Save
          </Button> */}

        </div>
        
        <div className= { `${ commonStyles.wrapper } ${ RfsStyles.wrapper }` }>
          <h3 className={ commonStyles.header }> Orders </h3>
          <MaterialTable
            components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>}}
            columns={[
              {
                title: 'Order',
                field: '',
                render: (orders: any) => {
                  return orders.number;
                },
              },
              {
                title: 'Driver',
                field: 'driver_name'
              },
              {
                title: 'Action',
                headerStyle: { textAlign: 'center' },
                cellStyle: { minWidth: '100px', textAlign: 'center' },
                render: (rowData: any) => {
                  return (
                    <span className={classes.awbActionsList}>
                      <Tooltip title=''>
                        <img alt="logo" src={ unlink } className={ props.classes.linkButton } onClick={ () => props.openConfirmation('link', props.tapaForm.id, rowData.number) }/>
                      </Tooltip>
                    </span>
                  );
                },
              },
            ]}
            data={props.tapaForm.orders}
            options={{
              paging: false,
              pageSize: 10,
              headerStyle: {
                backgroundColor: 'var(--tbl_head_bkg)',
                color: 'var(--tbl_head_color)',
                zIndex: 2,
              },
              showTitle: false,
              pageSizeOptions: [15, 20],
              toolbar: false,
              sorting: false,
            }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default withStyles(styles)(tapaLinkModalComponent);
